<template>
  <div class="styleguides">
    <div id="Colors" class="colors box">
      <div class="container">
        <div class="box__title">
          <h5 class="text-sans-xl text-gray-700">Colors</h5>
        </div>

        <div class="box__example">
          <p class="text-sans-lg">Gray scale</p>
          <ul class="flex py-4">
            <li class="col-auto px-4">
              <div class="color-round bg-gray-100"></div>
              <p class="font-bold mt-2">#F2F2F2</p>
            </li>
            <li class="col-auto px-4">
              <div class="color-round bg-gray-300"></div>
              <p class="font-bold mt-2">#E2E2E2</p>
            </li>
            <li class="col-auto px-4">
              <div class="color-round bg-gray-400"></div>
              <p class="font-bold mt-2">#D2D2D2</p>
            </li>
            <li class="col-auto px-4">
              <div class="color-round bg-gray-600"></div>
              <p class="font-bold mt-2">#9D9D9D</p>
            </li>
            <li class="col-auto px-4">
              <div class="color-round bg-gray-700"></div>
              <p class="font-bold mt-2">#979797</p>
            </li>
          </ul>
        </div>

        <div class="box__example">
          <p class="text-sans-lg">Blue scale</p>
          <ul class="flex py-4">
            <li class="col-auto px-4">
              <div class="color-round bg-blue-500"></div>
              <p class="font-bold mt-2">#4A90E2</p>
            </li>

            <li class="col-auto px-4">
              <div class="color-round bg-blue-600"></div>
              <p class="font-bold mt-2">#3677C3</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div id="Typography" class="typografy box">
      <div class="container">
        <div class="box__title">
          <h5 class="text-sans-xl text-gray-600">Typography</h5>
        </div>

        <div class="box__example">
          <p class="text-sans-xs">Ondealte | .text-sans-xs</p>
          <pre
            class="box__code"
          ><code>&lt;p class="text-sans-xs"&gt;Ondealte | .text-sans-xs&lt;/p&gt;</code></pre>
        </div>

        <hr />

        <div class="box__example">
          <p class="text-sans-sm">Ondealte | .text-sans-sm</p>
          <pre
            class="box__code"
          ><code>&lt;p class="text-sans-sm"&gt;Ondealte | .text-sans-sm&lt;/p&gt;</code></pre>
        </div>

        <hr />

        <div class="box__example">
          <p class="text-sans-base">Ondealte | .text-sans-base</p>
          <pre
            class="box__code"
          ><code>&lt;p class="text-sans-base"&gt;Ondealte | .text-sans-base&lt;/p&gt;</code></pre>
        </div>

        <hr />

        <div class="box__example">
          <p class="text-sans-lg">Ondealte | .text-sans-lg</p>
          <pre
            class="box__code"
          ><code>&lt;p class="text-sans-lg"&gt;Ondealte | .text-sans-lg&lt;/p&gt;</code></pre>
        </div>

        <hr />

        <div class="box__example">
          <p class="text-sans-xl">Ondealte | .text-sans-xl</p>
          <pre
            class="box__code"
          ><code>&lt;p class="text-sans-xl"&gt;Ondealte | .text-sans-xl&lt;/p&gt;</code></pre>
        </div>
      </div>
    </div>

    <div id="Buttons" class="buttons box">
      <div class="container">
        <div class="box__title">
          <h5 class="text-sans-xl text-gray-600">Buttons</h5>
        </div>

        <div class="box__example">
          <button class="btn-default">Seleziona</button>
          <pre
            class="box__code"
          ><code>&lt;button class=&quot;btn-default&quot;&gt;Seleziona&lt;/button&gt;</code></pre>
        </div>

        <hr />

        <div class="box__example">
          <button class="btn-primary">Pubblica</button>
          <pre
            class="box__code"
          ><code>&lt;button class=&quot;btn-primary&quot;&gt;Pubblica&lt;/button&gt;</code></pre>
        </div>

        <hr />

        <div class="box__example">
          <button class="btn-secondary">Pubblica</button>
          <pre
            class="box__code"
          ><code>&lt;button class=&quot;btn-secondary&quot;&gt;Pubblica&lt;/button&gt;</code></pre>
        </div>

        <hr />

        <div class="box__example">
          <ul class="flex py-4">
            <li class="col-auto pr-4">
              <button class="btn-secondary btn-icon-l">
                <IconTrash /> Cancella
              </button>
            </li>
            <li class="col-auto px-4">
              <button class="btn-secondary btn-icon-r">
                Sposta in <IconFolder />
              </button>
            </li>
          </ul>
          <pre
            class="box__code"
          ><code>&lt;button class=&quot;btn-secondary btn-icon-l&quot;&gt;&lt;IconTrash /&gt; Cancella&lt;/button&gt;<br>&lt;button class=&quot;btn-secondary btn-icon-r&quot;&gt;Sposta in &lt;IconFolder /&gt;&lt;/button&gt;</code></pre>
        </div>

        <hr />

        <div class="box__example">
          <button class="btn-round-icon"><IconArrowDown /></button>
          <pre
            class="box__code"
          ><code>&lt;button class=&quot;btn-round-icon&quot;&gt;&lt;IconArrowDown /&gt;&lt;/button&gt;</code></pre>
        </div>
      </div>
    </div>

    <div id="Forms" class="forms box">
      <div class="container">
        <div class="box__title">
          <h5 class="text-sans-xl text-gray-600">Forms</h5>
        </div>

        <div class="box__example">
          <input
            class="form-input-text"
            placeholder="Inserisci qui il nome della cartella"
            type="text"
            name="test"
          />
          <pre
            class="box__code"
          ><code>&lt;input class="form-input-text"placeholder="Inserisci qui il nome della cartella" type="text" name="test"/&gt;</code></pre>
        </div>

        <hr />

        <div class="box__example">
          <input class="form-input-checkbox" type="checkbox" name="test" />
          <input class="form-input-radio ml-4" type="radio" name="test" />
          <pre
            class="box__code"
          ><code>&lt;input class="form-input-checkbox" type="checkbox" name="test" /&gt;<br>&lt;input class="form-input-radio" type="radio" name="test" /&gt;</code></pre>
        </div>

        <div class="box__example">
          <SelectVue
            name="test"
            :choices="select"
            placeholder="Seleziona Opzione"
            :first-option="true"
          ></SelectVue>
          <pre class="box__code"><code>&lt;SelectVue
            name="test"
            :choices="select"
            placeholder="Seleziona Opzione"
            :first-option="true"
          &gt;&lt;/SelectVue&gt;</code></pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/** Components */
import SelectVue from '@/components/fields/SelectVue.vue'

/** Icons */
import IconTrash from '@/assets/icons/icon-trash.svg'
import IconFolder from '@/assets/icons/icon-folder.svg'
import IconArrowDown from '@/assets/icons/icon-arrow_down.svg'

export default {
  components: {
    IconTrash,
    IconFolder,
    SelectVue,
    IconArrowDown,
  },

  computed: {
    select() {
      return [
        {
          value: '',
          label: 'Seleziona un Opzione',
          active: false,
          disabled: false,
        },
        {
          value: 'prima-scelta',
          label: 'Perima Scelta',
          active: false,
          disabled: true,
        },
        {
          value: 'seconda-scelta',
          label: 'Seconda Scelta',
          active: true,
          disabled: false,
        },
      ]
    },
  },
}
</script>

<style lang="scss">
.box {
  @include e(title) {
    @apply py-3 mb-4;
  }

  @include e(example) {
    @apply py-3;
  }

  @include e(code) {
    @apply mt-3;
  }
}

.color-round {
  @apply w-8 h-8 m-auto rounded-full;
}
</style>
